<div class="entity-info-card" [ngClass]="'entity-info-card--' + resolvedVariant">
  <div class="entity-info-card__icon">
    <i [class]="resolvedIcon"></i>
  </div>
  <div class="entity-info-card__content">
    <span *ngIf="label" class="entity-info-card__label">{{ label }}</span>
    <div class="entity-info-card__body">
      <span *ngIf="value" class="entity-info-card__value">
        {{ value }}
        <span *ngIf="subValue" class="entity-info-card__sub-value">({{ subValue }})</span>
      </span>
      <span *ngIf="description" class="entity-info-card__desc">{{ description }}</span>
      <ng-content></ng-content>
    </div>
  </div>
</div>
